import { colors } from "./colors";
const isValidColor = (color) => {
    if (typeof document === "undefined") {
        return false; // shouldn't happen, code should only run in browser
    }
    const s = new Option().style;
    s.color = color;
    return s.color !== "";
};
export function colorMarkSpec() {
    return {
        color: {
            attrs: {
                color: { default: null },
            },
            parseDOM: [
                {
                    style: "color",
                    getAttrs: (color) => {
                        const colorOption = colors.find((option) => {
                            return option.value === color;
                        });
                        if (!colorOption && isValidColor(color)) {
                            return { color };
                        }
                        if (!colorOption) {
                            return false;
                        }
                        return { color: colorOption.class };
                    },
                },
                {
                    tag: "span.text-color",
                    getAttrs: (node) => {
                        const className = node.className;
                        const colorOption = colors.find((option) => className.includes(option.class));
                        if (!colorOption && isValidColor(getComputedStyle(node).color)) {
                            return { color: getComputedStyle(node).color };
                        }
                        if (!colorOption) {
                            return false;
                        }
                        return { color: colorOption.class };
                    },
                },
            ],
            toDOM: (node) => {
                const attrs = node.attrs;
                const colorOption = colors.find((option) => option.class === attrs.color);
                if (!colorOption && isValidColor(attrs.color)) {
                    return [
                        "span",
                        {
                            class: `text-color`,
                            style: `color: ${attrs.color}`,
                        },
                        0,
                    ];
                }
                if (!colorOption) {
                    return ["span", 0];
                }
                return [
                    "span",
                    {
                        class: `text-color text-color--${colorOption.class}`,
                        style: `color: ${colorOption.value}`,
                    },
                    0,
                ];
            },
        },
    };
}
